var map = {
	"./icon-checks.svg": "./stuurlui-lowcode/src/img/icon-checks.svg",
	"./icon-strl-white.svg": "./stuurlui-lowcode/src/img/icon-strl-white.svg",
	"./icon-stuurlui-blue.svg": "./stuurlui-lowcode/src/img/icon-stuurlui-blue.svg",
	"./icon-stuurlui-global.svg": "./stuurlui-lowcode/src/img/icon-stuurlui-global.svg",
	"./logo.svg": "./stuurlui-lowcode/src/img/logo.svg",
	"./strl-16px.png": "./stuurlui-lowcode/src/img/strl-16px.png",
	"./strl-36px.png": "./stuurlui-lowcode/src/img/strl-36px.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./stuurlui-lowcode/src/img sync recursive ^\\.\\/.*$";